import { createTheme } from '@mui/material/styles';
import { colors, radii, typography as typeTokens } from './design/tokens';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: colors.brand.primary,
      light: colors.brand.primaryLight,
      dark: colors.brand.primaryDark,
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: colors.brand.accent,
      dark: colors.brand.accentDark,
      contrastText: '#0B0F19',
    },
    background: {
      default: colors.neutral.surface,
      paper: colors.neutral.surfaceElevated,
    },
    text: {
      primary: colors.neutral.ink,
      secondary: colors.neutral.inkMuted,
    },
    divider: colors.neutral.border,
  },
  typography: {
    fontFamily: typeTokens.fontFamily.sans,
    h1: { fontSize: '2.75rem', fontWeight: typeTokens.weight.bold, letterSpacing: '-0.03em', lineHeight: 1.15 },
    h2: { fontSize: '2.125rem', fontWeight: typeTokens.weight.bold, letterSpacing: '-0.02em' },
    h3: { fontSize: '1.75rem', fontWeight: typeTokens.weight.semibold },
    h4: { fontSize: '1.375rem', fontWeight: typeTokens.weight.semibold },
    h5: { fontSize: '1.125rem', fontWeight: typeTokens.weight.semibold },
    h6: { fontSize: '1rem', fontWeight: typeTokens.weight.semibold },
    button: { fontWeight: typeTokens.weight.semibold, textTransform: 'none' },
    body1: { lineHeight: 1.65 },
    body2: { lineHeight: 1.6 },
  },
  shape: { borderRadius: radii.md },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: radii.sm,
          fontWeight: typeTokens.weight.semibold,
          padding: '10px 18px',
        },
        sizeLarge: { padding: '12px 22px', fontSize: '1rem' },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: typeTokens.weight.medium, borderRadius: radii.pill },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: radii.lg,
          boxShadow: '0 1px 2px rgba(11, 15, 25, 0.05)',
          border: `1px solid ${colors.neutral.border}`,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: { borderRadius: radii.lg },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: { borderRadius: radii.sm },
      },
    },
  },
});

export default theme;
